export default __webpack_public_path__ + "static/media/earsicon.d70d4c6a.png";